import React from "react";
import MediaTable from "../../../components/Tables/MediaTable";
import { useDataSets } from "../../../contexts/DataSetsContext";

export const DataItems = ({ style = {} }) => {
  const { selectedDataSetItems, selectedDataItem, loadingDataItem } = useDataSets();

  console.log("!!! SELECTED DATA SET ITEMS: ", selectedDataSetItems);

  return (
    <div style={{ width: "100%", position: "relative", ...style }}>
      {
        selectedDataItem || loadingDataItem ? (
          <div>{loadingDataItem ? "Loading Data Item" : `Selected data item: ${selectedDataItem}`}</div>
        ) : (
          <MediaTable media={selectedDataSetItems} showAddExisting={true} isDataSet={true} hideTitle={true} />
        )}
    </div >
  );
};

export default DataItems;
